import registerForRails from 'js/utils/registerForRails';
import AboutHiringNavbar from 'js/about_hiring/AboutHiringNavbar';
import AdminBar from 'js/admin_bar/AdminBarActivator';
import AshbyJobs from 'js/ashby_job_postings/AshbyJobs';
import Carousel from 'js/about_hiring/Carousel';
import Accordion from 'js/about_hiring/Accordion';

registerForRails(
  {
    AboutHiringNavbar,
    AdminBar,
    AshbyJobs,
    Carousel,
    Accordion,
  },
  [
    'js/about_hiring/AboutHiringNavbar',
    'js/admin_bar/AdminBar',
    'js/ashby_jobs_postings/AshbyJobs',
    'js/about_hiring/Carousel',
    'js/about_hiring/Accordion',
  ],
);
